(() => {
  const WIDGET_SELECTOR = '#PromiseEddSection';
  let updateQueued = false;

  function queueUpdate() {
    if (updateQueued) return;
    updateQueued = true;

    window.requestAnimationFrame(() => {
      updateQueued = false;
      updateWidget();
    });
  }

  function updateResultText(widget) {
    const result = widget.querySelector('#delivery-msg .sr-promise-theme2-text');
    if (!result) return;

    const prefix = Array.from(result.childNodes).find(
      (node) => node.nodeType === Node.TEXT_NODE && /Get it by|Estimated Delivery by/i.test(node.textContent)
    );

    if (prefix && prefix.textContent !== 'Estimated Delivery by ') {
      prefix.textContent = 'Estimated Delivery by ';
    }
  }

  function prepareInput(widget) {
    const input = widget.querySelector('#sr-promise-enter-pincode-input');
    if (!input) return false;

    input.placeholder = 'Enter Pincode';
    input.setAttribute('aria-label', 'Enter Pincode');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('autocomplete', 'postal-code');

    const button = widget.querySelector('#enter-pincode [onclick*="applyPromisePincode"]');
    if (button) {
      if (button.textContent.trim() !== 'Check') button.textContent = 'Check';
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-label', 'Check estimated delivery date');

      if (!button.dataset.nostrumKeyboardReady) {
        button.dataset.nostrumKeyboardReady = 'true';
        button.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            button.click();
          }
        });
      }
    }

    return true;
  }

  function showInput(widget) {
    if (prepareInput(widget)) return;
    if (widget.dataset.nostrumOpeningInput === 'true') return;
    if (typeof window.editPromisePincode !== 'function') return;

    widget.dataset.nostrumOpeningInput = 'true';
    window.editPromisePincode();

    window.requestAnimationFrame(() => {
      delete widget.dataset.nostrumOpeningInput;
      prepareInput(widget);
    });
  }

  function updateWidget() {
    const widget = document.querySelector(WIDGET_SELECTOR);
    if (!widget) return;

    // The app supplies inline !important Arial styles. Use the theme font.
    const themeFont = 'var(--font-body-family, inherit)';
    if (widget.style.fontFamily !== themeFont) {
      widget.style.setProperty('font-family', themeFont, 'important');
    }
    widget.querySelectorAll('[style]').forEach((element) => {
      if (element.style.fontFamily && element.style.fontFamily !== 'inherit') {
        element.style.setProperty('font-family', 'inherit', 'important');
      }
    });

    let title = widget.querySelector(':scope > .nostrum-edd-title');
    if (!title) {
      title = document.createElement('div');
      title.className = 'nostrum-edd-title';
      title.textContent = 'Check Estimated Delivery Date';
      widget.prepend(title);
    }

    updateResultText(widget);
    showInput(widget);
  }

  const observer = new MutationObserver(queueUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  } else {
    queueUpdate();
  }

  window.addEventListener('load', queueUpdate, { once: true });
})();
